module.exports = __webpack_public_path__ + "static/media/icon-webdesign.bfa534e8.svg";